/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useState } from "react";
// import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { injectIntl, intlShape } from "react-intl";
import { Loader, Card, CardSection } from "cxa-components";
import ClaimStepper from "./ClaimStepper";
import { getClaimDocuments, getClaimAccounts, getClaimItem } from "../../actions/claimActionsPP";
import messages from "components/messagesDescription";
import withMatchMediaProps from "@hocs/with-match-media-props";
import ClaimSubmissionGuideline from "./widgets/ClaimSubmissionGuideline";
import AddDocumentsForm from "./AddDocumentsForm";
import ClaimRHS from "./ClaimRHS";

const AddDocuments = props => {
  const {
    match: { params },
    intl,
  } = props;
  const dispatch = useDispatch();
  const data = useSelector(state => state.claimsPP);
  const claimItemData = useSelector(state => state.claimsPP.claimItem);

  useEffect(() => {
    dispatch(getClaimDocuments(params.claimId, params.selectedDelegator));
  }, []);
  useEffect(() => {
    data.documents &&
      dispatch(
        getClaimAccounts(
          data.documents.planYear,
          data.documents.claimItemId,
          params.selectedDelegator
        )
      );
    data.documents &&
      dispatch(
        getClaimItem(data.documents.planYear, data.documents.claimItemId, params.selectedDelegator)
      );
    //Scroll to the top of the page
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [data.documents]);

  const supportingDocuments =
    data.documents && data.documents.uploadSupportingDocuments
      ? [...data.documents.uploadSupportingDocuments.uploadedFiles]
      : [];
  const referral =
    data.documents && data.documents.uploadReferral
      ? data.documents.uploadReferral.activeFile
      : null;

  const initialValues = {
    claimId: params.claimId,
    supportingDocuments: supportingDocuments,
    referral: referral,
  };
  if (referral && referral.renamedReferral) {
    initialValues.renameReferral = referral.renamedReferral;
  }

  const hasKeySupportingDocsGuideline = intl.messages.hasOwnProperty("config.supportingDocsGuide");
  return (
    <Fragment>
      <ClaimStepper index={2} />
      {!data.documents ? (
        <Loader />
      ) : (
        <div className="csp-side-menu">
          <h3>
            <span className="claim-header">
              {props.intl.formatMessage(messages.claims.addDocumentsDescription)}
            </span>
          </h3>
          <div className="claim-form-container">
            <div className="cxa-grid__item--nine">
              <Card>
                {data.documents && (
                  <CardSection>
                    <div>
                      {intl.formatMessage(messages.planYearDescription)}
                      <strong>
                        {": "}
                        {data.documents.planYear}
                      </strong>
                    </div>
                    <div>
                      {intl.formatMessage(messages.ClaimItemTypeDescription)}
                      <strong>
                        {": "}
                        {intl.formatMessage({
                          id: data.documents.claimFormTitle,
                          defaultMessage: data.documents.claimFormTitle,
                        })}
                      </strong>
                    </div>
                    {claimItemData && (
                      <ClaimSubmissionGuideline
                        title={intl.formatMessage(
                          messages.claims.referralAndSupportingDocumentsGuideline
                        )}
                      >
                        {hasKeySupportingDocsGuideline ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: intl.messages["config.supportingDocsGuide"],
                            }}
                          />
                        ) : (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: claimItemData.claimSubmissionReferralSupportingDocs,
                            }}
                          />
                        )}
                      </ClaimSubmissionGuideline>
                    )}
                  </CardSection>
                )}
                <AddDocumentsForm {...props} initialValues={initialValues} />
              </Card>
            </div>
            <div className="cxa-grid__item--three claim-panel-mobile-container">
              <ClaimRHS {...props} />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

AddDocuments.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(
  withMatchMediaProps({
    isNarrowScreen: {
      maxWidth: 680,
    },
  })(AddDocuments)
);



// WEBPACK FOOTER //
// ./components/claim/AddDocuments.js